export class Constants {
  static get MinSearchChars() {
    return 3;
  }
  static get TaskType() {
    return {
      TXNOPP: 'txnOpp',
      AUCTION: 'auction',
    };
  }

  static get Username() {
    return {
      AUTOCALC: 'AUTOCALC',
      MLSFEED: 'MLSFeed',
      CRMFEED: 'CRMFeed',
    };
  }

  static get Visibility() {
    return {
      SHOW: 'show',
      HIDE: 'hide',
    };
  }

  static get PropertyUWProformaInputControlType() {
    return {
      TEXTFIELD: 'textField',
      RADIO: 'radio',
    };
  }

  static get MasterStatus() {
    return {
      IMPORTED: 'Imported',
      AVAILABLE: 'Available',
      ASSIGNED: 'Assigned',
      UNDERWRITEDONE: 'UnderwriteDone',
      NOBID: 'NoBid',
      SUBMITTED: 'Submitted',
      COMPLETED: 'Completed',
      EXPIRED: 'Expired',
      TERMINATED: 'Terminated',
    };
  }

  static get ActiveReason() {
    return {
      NEWLISTING: 'NewListing',
      PRICECHANGE: 'PriceChange',
      BACKONMARKET: 'BackOnMarket',
      STALE: 'Stale',
    };
  }

  static get OpportunityStatus() {
    return {
      IMPORTED: 'Imported',
      PRESCREEN: 'PreScreen',
      INITIAL: 'Initial',
      COUNTER: 'Counter',
      DUEDILIGENCE: 'DueDiligence',
      TERMINATED: 'Terminated',
      COMPLETED: 'Completed',
    };
  }

  static get UnderwriteStatus() {
    // Nullable
    return {
      SAVEDNOBID: 'SavedNoBid',
      SAVEDPRICING: 'SavedPricing',
      SUBMISSIONPENDING: 'SubmissionPending',
      SUBMISSIONFAILED: 'SubmissionFailed',
      SUBMITTEDNOBID: 'SubmittedNoBid',
      SUBMITTEDPRICING: 'SubmittedPricing',
      PENDING: 'Pending',
      AUTOPRICED: 'Autopriced',
    };
  }

  // These values need to match backend Channel enum string value, case sensitive
  static get Channel() {
    return {
      AUCTION: 'Auction',
      MLS: 'MLS',
      BULKSALE: 'BulkSale',
      BUILDTORENT: 'BuildToRent',
      OFFMARKET: 'OffMarket',
      // OTHER: 'Other'
    };
  }

  static get Module() {
    return {
      EXPLORE: 'explore',
      UNDERWRITE: 'underwrite',
      DASHBOARD: 'dashboard',
      ADMIN: 'admin',
      POSTACQ: 'postAcq'
    };
  }

  static get ImportType() {
    return {
      TITLES: 'titles',
      PROPERTIES: 'properties',
      OPPORTUNITIES: 'opportunities',
      BACKFILL: 'backfill',
      POSTACQTASKS: 'postAcqTasks'
    };
  }

  static get ImportSource() {
    return {
      ManualImport: 'ManualImport',
    };
  }

  // Backend also have this setup in appSettings.js, we need to sync these two places
  static get ImportMaxCount() {
    return {
      PROPERTIES: 2000,
      OPPORTUNITIES: 2000,
      TITLES: 2000,
      BACKFILL: 1000,
      POSTACQTASKS: 5000
    };
  }

  static get Routes() {
    return {
      EXPLORE: '/explore',
      EXPLORE_IMPORT: '/explore/import',
      EXPLORE_IMPORT_PROPERTY: '/explore/import/property',
      EXPLORE_IMPORT_PROPERTY_HISTORY: '/explore/import/importPropertyHistory',
      EXPLORE_IMPORT_STATUS: '/explore/import/status',
      EXPLORE_PROSPECTOR: '/explore/prospector',
      EXPLORE_PROSPECTOR_ADD_PROPERTY: '/explore/prospector/add',
      EXPLORE_CONDUCTOR: '/explore/conductor',
      UNDERWRITE: '/underwrite',
      CHANNEL_WORKFLOW: '/underwrite/workflow',
      UNDERWRITE_PROPERTY: '/underwrite/propuw',
      UNDERWRITE_AUCTION: '/underwrite/auctionuw',
      UNDERWRITE_IMPORT: '/underwrite/import',
      UNDERWRITE_IMPORT_OPPORTUNITY: '/underwrite/import/opportunity',
      UNDERWRITE_IMPORT_TITLE: '/underwrite/import/title',
      UNDERWRITE_IMPORT_OPPORTUNITY_HISTORY:
        '/underwrite/import/importOpportunityHistory',
      UNDERWRITE_IMPORT_REJECTED_IMPORTS: '/underwrite/import/rejectedImports',
      UNDERWRITE_IMPORT_STATUS: '/underwrite/import/status',
      DASHBOARD: '/dashboard',
      DASHBOARD_SEARCH: '/dashboard/search',
      POSTACQ: '/postAcq',
      POSTACQ_WORKFLOW: '/postAcq/workflow',
      POSTACQ_TASK: '/postAcq/task',
      POSTACQ_IMPORT: '/postAcq/import',
      POSTACQ_IMPORT_TASK: '/postAcq/import/task',
      POSTACQ_IMPORT_TASK_HISTORY: '/postAcq/import/importTaskHistory',
      ADMINISTRATION: '/admin',
      LOGIN_PATH: '/login',
      LOGIN_CALLBACK_PATH: '/login/callback',
      ASSUMPTIONS: '/admin/assumptions',
      HOME: ''
    };
  }

  static get RouteTitles() {
    return {
      EXPLORE: 'Explore',
      EXPLORE_IMPORT: '',
      EXPLORE_IMPORT_PROPERTY: 'Property Import',
      EXPLORE_IMPORT_PROPERTY_HISTORY: 'Property Import History',
      EXPLORE_IMPORT_STATUS: 'Property Import Status',
      EXPLORE_PROSPECTOR: 'Add Prospect',
      EXPLORE_PROSPECTOR_ADD_PROPERTY: 'Add Prospect',
      EXPLORE_CONDUCTOR: 'Prospects',
      UNDERWRITE: 'My Opps',
      CHANNEL_WORKFLOW: 'Workflow',
      UNDERWRITE_PROPERTY: 'Opportunity Underwrite',
      UNDERWRITE_AUCTION: 'Auction Underwrite',
      UNDERWRITE_IMPORT: '',
      UNDERWRITE_IMPORT_OPPORTUNITY: 'Opportunity Import',
      UNDERWRITE_IMPORT_TITLE: 'Title Import',
      UNDERWRITE_IMPORT_OPPORTUNITY_HISTORY: 'Opportunity Import History',
      UNDERWRITE_IMPORT_REJECTED_IMPORTS: 'Rejected Imports',
      UNDERWRITE_IMPORT_STATUS: 'Opportunity Import Status',
      DASHBOARD: 'Dashboard',
      DASHBOARD_SEARCH: 'Search',
      POSTACQ: 'Post-Acq',
      POSTACQ_WORKFLOW: 'Post-Acq Workflow',
      POSTACQ_TASK: 'Post-Acq Task',
      POSTACQ_IMPORT: 'Post-Acq Import',
      POSTACQ_IMPORT_TASK: 'Task Import',
      POSTACQ_IMPORT_TASK_HISTORY: 'Task Import History',
      ADMINISTRATION: 'Administration',
      LOGIN_PATH: '',
      LOGIN_CALLBACK_PATH: '',
      ASSUMPTIONS: 'Assumptions',
      HOME: ''
    };
  }

  static get PmStatus() {
    return {
      FOUND_PROP: 'FoundProp',
      ADDED_PROP_PROVISIONAL: 'AddedPropProvisional',
    };
  }

  static get SignalRUpdateTarget() {
    return {
      CLIENTTXNOPPS: 'clientTxnOpps',
      QUEUETXNOPPS: 'queueTxnOpps',
      PROPERTYUWTXNOPP: 'propertyUWTxnOpp',
      AUCTIONUWTXNOPPS: 'auctionUWTxnOpps',
      POSTACQWORKFLOWTASKS: 'postAcqWorkflowTasks',
      POSTACQQUEUETASKS: 'postAcqQueueTask',
      POSTACQUWTASK: 'postAcqUWTask'
    };
  }

  static get SignalRActionType() {
    // Must sync with backend ActionType.cs
    return {
      APPLYREPAIRSTOVALUATION: 'ApplyRepairsToValuation',
      ASSIGNPORTFOLIO: 'AssignPortfolio',
      ASSIGNTXNOPP: 'AssignTxnOpp',
      AUTOPRICINGSTARTED: 'AutopricingStarted',
      AUTOPRICINGFINISHED: 'AutopricingFinished',
      COMPLETEAUCTION: 'CompleteAuction',
      IMPORTTITLE: 'ImportTitle',
      ORDERINSPECTION: 'OrderInspection',
      PUSHTOPRISM: 'PushToPrism',
      PUSHTOCRM: 'PushToCrm',
      SAVEORUPDATEVALUATION: 'SaveOrUpdateValuation',
      SETSELECTEDVALUATION: 'SetSelectedValuation',
      SYNCINSPECTION: 'SyncInspection',
      SYNCAUCTIONRESULT: 'SyncAuctionResult',
      SYNCPRISMSTATE: 'SyncPrismState',
      SYNCCRMSTATE: 'SyncCrmState',
      SYNCPURCHASINGSTATE: 'SyncPurchasingState',
      STATUSOVERRIDESYNC: 'StatusOverrideSync',
      TERMINATETXNOPP: 'TerminateTxnOpp',
      UNTERMINATETXNOPP: 'UnterminateTxnOpp',
      UNASSIGNPORTFOLIO: 'UnassignPortfolio',
      UNASSIGNTXNOPP: 'UnassignTxnOpp',
      UPDATEBID: 'UpdateBid',
      SHOWOPPORTUNITY: 'ShowOpportunity',
      HIDEOPPORTUNITY: 'HideOpportunity',
      RELOADTXNOPPS: 'ReloadTxnOpps',
      SUBMITTOUNDERWRITE: 'SubmitToUnderwrite',
      REQUESTALLOCATION: 'RequestAllocation',
      DELETETXNOPP: 'DeleteTxnOpp',
      POSTACQUISITIONLOADSTARTED: 'PostAcquisitionLoadStarted',
      POSTACQUISITIONLOADFINISHED: 'PostAcquisitionLoadFinished',
      DELETEPOSTACQUISITIONTASK: 'DeletePostAcquisitionTask',
      SAVEPOSTACQUISITIONVALUATION: 'SavePostAcquisitionValuation'
    };
  }

  static get ViewsObjectType() {
    return {
      PROPERTYDATA: 'PropertyData',
      MARKETS: 'Markets',
      PIN: 'Pin',
      LINE: 'Line',
      SHAPE: 'Shape',
      DISTANCEMEASURING: 'DistanceMeasuring',
      CIRCLE: 'Circle',
      LABEL: 'Label',
    }
  }

  static get ViewsObjectCountLimit() {
    return {
      [this.ViewsObjectType.PROPERTYDATA]: 20,
      [this.ViewsObjectType.MARKETS]: 5,
      [this.ViewsObjectType.PIN]: 50,
      [this.ViewsObjectType.LINE]: 50,
      [this.ViewsObjectType.SHAPE]: 50,
      [this.ViewsObjectType.DISTANCEMEASURING]: 50,
      [this.ViewsObjectType.CIRCLE]: 50,
      [this.ViewsObjectType.LABEL]: 50,
    }
  }

  static get ViewsPropertyDataGeoFilterAreaLimit() {
    return 20720000000; // in sq meters, equal to 8,000 sq mi
  }

  static get ViewsCharLimit() {
    return {
      VIEWNAME: 50,
      VIEWDESCRIPTION: 200,
      LAYERNAME: 50,
      OBJECTDESCRIPTION: 200
    }
  }

  static get ViewsPropertyDataPinColor() { // Sync with image imports in components/explore/gmap/colorHelper.js
    return {
      RED: 'red',
      ORANGE: 'orange',
      YELLOW: 'yellow',
      LIGHTGREEN: 'lightGreen',
      GREEN: 'green',
      LIGHTBLUE: 'lightBlue',
      BLUE: 'blue',
      PURPLE: 'purple',
      GRAY: 'gray'
    }
  }

  static get UnderwriteMinAskingPrice() {
    return 50000; // Sync value with backend IsValidAskingPrice rule in ValidationService
  }

  static get PostAcqTaskStatus() {
    return {
      OPEN: 'Open',
      CLOSED: 'Closed'
    }
  }

  static get PostAcqUnderwriteStatus() {
    return {
      SAVED: 'Saved',
      SUBMITTED: 'Submitted'
    }
  }

  static get DisplayMode() {
    return {
      MOBILE: 'mobile',
      LAPTOP: 'laptop',
      DESKTOP: 'desktop'
    }
  }
}

export function getModuleByLocation(location) {
  if (!location?.pathname) return null;
  const { pathname } = location;

  if (pathname.startsWith(Constants.Routes.EXPLORE)) {
    return Constants.Module.EXPLORE;
  } else if (pathname.startsWith(Constants.Routes.UNDERWRITE)) {
    return Constants.Module.UNDERWRITE;
  } else if (pathname.startsWith(Constants.Routes.DASHBOARD)) {
    return Constants.Module.DASHBOARD;
  } else if (pathname.startsWith(Constants.Routes.ADMINISTRATION)) {
    return Constants.Module.ADMIN;
  } else if (pathname.startsWith(Constants.Routes.POSTACQ)) {
    return Constants.Module.POSTACQ;
  } else {
    return null;
  }
}
